import { useContext } from 'react';
import { DashboardCtx, type DashboardContextValue } from './dashboardCtx';

export function useDashboard(): DashboardContextValue {
  const ctx = useContext(DashboardCtx);
  if (!ctx) throw new Error('useDashboard must be used within DashboardProvider');
  return ctx;
}
